// Site scripts entry point
// Import any external dependencies using the rollup nodeResolve plugin
// e.g. import "@mux/mux-video";

// Import internal dependencies
import "./search.js";
import {
  backToTopButtonObserver,
  backToTopLinkObserver,
  trackTocLinks,
  trackTocSections,
  localeSwitcher,
  progressBar,
  enhanceBackLink,
} from "./utils.js";

const hlsVideo = document.querySelector("video[data-hls-src]");
if (hlsVideo) {
  const hlsPlayerScript = document.createElement("script");
  hlsPlayerScript.type = "module";
  hlsPlayerScript.src = hlsVideo.dataset.hlsPlayerSrc;
  document.body.append(hlsPlayerScript);
}

function initSite() {
  const header = document.querySelector("#header");
  if (!header) return;

  backToTopButtonObserver.observe(header);
  backToTopLinkObserver.observe(header);
  trackTocLinks();
  trackTocSections();
  localeSwitcher();
  progressBar();
  enhanceBackLink();
}

// Modern event listener pattern
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSite);
} else {
  initSite();
}
